import { ModuleWithProviders } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ErrorComponent, PagedTableWrapperComponent } from "@mango/core";
import { AuthGuard } from "@mango/authentication";
import { AUTHORIZATION_ROUTES } from "@mango/authorization";

import { UserCollectionComponent } from "./user/user-collection.component";
import { UserFilterComponent } from "./user/user-filter.component";
import { UserComponent } from "./user/user.component";

import { AlertCollectionComponent } from "./alert/alert-collection.component";
import { AlertFilterComponent } from "./alert/alert-filter.component";
import { AlertComponent } from "./alert/alert.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { SuselbeekActivateAccountComponent } from "./login/activate-account/activate-account.component";
import { AppLoginComponent } from "./login/login.component";
import { RegisterComponent } from "./register/register.component";
import { BaseLayoutComponent } from "./shared/components/base-layout/base-layout.component";
import { UnregisterComponent } from "./unregister/unregister.component";
import { VisitorCollectionComponent } from "./visitor/visitor-collection/visitor-collection.component";
import { VisitorFilterComponent } from "./visitor/visitor-filter/visitor-filter.component";
import { VisitorComponent } from "./visitor/visitor/visitor.component";
import { MainComponent } from "./main/main.component";

const routes: Routes = [
  {
    path: "",
    component: BaseLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "frontdesk",
        pathMatch: "full"
      },
      {
        path: "frontdesk",
        children: [
          {
            path: "",
            redirectTo: "50/0/-6",
            pathMatch: "full"
          },
          {
            path: ":ps/:pi/:sort",
            component: PagedTableWrapperComponent,
            data: {
              collection: VisitorCollectionComponent,
              filter: VisitorFilterComponent,
              title: "Bezoekersoverzicht",
              newItemRouterLink: ["/frontdesk/detail", "new"]
            }
          },
          {
            path: "detail/:id",
            component: VisitorComponent,
          },
        ]
      },
      {
        path: "authorization",
        children: AUTHORIZATION_ROUTES
      },
      {
        path: "users",
        children: [
          {
            path: "",
            redirectTo: "50/0/2",
            pathMatch: "full"
          },
          {
            path: ":ps/:pi/:sort",
            component: PagedTableWrapperComponent,
            data: {
              collection: UserCollectionComponent,
              filter: UserFilterComponent,
              title: "Gebruikers",
              newItemRouterLink: ["/users/detail", "new"]
            }
          },
          {
            path: "detail/:id",
            component: UserComponent
          }
        ]
      },
      {
        path: "alerts",
        children: [
          {
            path: "",
            redirectTo: "50/0/-2",
            pathMatch: "full"
          },
          {
            path: ":ps/:pi/:sort",
            component: PagedTableWrapperComponent,
            data: {
              collection: AlertCollectionComponent,
              filter: AlertFilterComponent,
              title: "Alerts"
            }
          },
          {
            path: "detail/:id",
            component: AlertComponent
          }
        ]
      },
    ]
  },
  {
    path: "main",
    component: MainComponent,
    children: [
      {
        path: "landing",
        component: LandingPageComponent,
        data: { animation: "LandingPage" }
      },
      {
        path: "register",
        component: RegisterComponent,
        data: { animation: "RegisterPage" }
      },
      {
        path: "unregister",
        component: UnregisterComponent,
        data: { animation: "UnregisterPage" }
      }
    ]
  },
  {
    path: "landing",
    redirectTo: "main/landing",
    pathMatch: "full"
  },
  {
    path: "error",
    component: ErrorComponent
  },
  {
    path: "activateAccount/:code",
    component: SuselbeekActivateAccountComponent
  },
  {
    path: "login",
    component: AppLoginComponent
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" });
